import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AboutSection } from './components/AboutSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
interface AppProps {
  showAnnouncementBar?: boolean;
}
export function App({
  showAnnouncementBar = true
}: AppProps) {
  return <div className="min-h-screen w-full bg-brand-cream font-sans text-brand-text selection:bg-brand-terra/20" data-id="element-0" data-mp="3mkhlps1j704z">
      <MetaPixel data-id="element-1" data-mp="3rdkie91luppe" />
      {showAnnouncementBar && <AnnouncementBar data-id="element-2" data-mp="3relvsk63foaa" />}
      <main data-id="element-3" data-mp="6hp9c27i9cj">
        <HeroSection data-id="element-4" data-mp="682rygdekbl" />
        <StatsBar data-id="element-5" data-mp="5gfdawxfswe" />
        <TransformationSection data-id="element-6" data-mp="82k72sfnuax" />
        <PainPointsSection data-id="element-7" data-mp="2zld4hgdhhrep" />
        <KitContentsSection data-id="element-8" data-mp="2zm4v0cs84yy4" />
        <InstantAccessSection data-id="element-9" data-mp="2zmwl5831y4h0" />
        <BonusesSection data-id="element-10" data-mp="33mf25srr5vek" />
        <PricingSection data-id="element-11" data-mp="33lx18iu5at0b" />
        <GuaranteeSection data-id="element-12" data-mp="33n6xd2hftr4b" />
        <TestimonialsSection data-id="element-13" data-mp="33oi1x4ipj2wh" />
        <AboutSection data-id="element-14" data-mp="38l8hlqqlnwhd" />
        <FAQSection data-id="element-15" data-mp="38l053zye2t6p" />
        <FinalCTASection data-id="element-16" data-mp="38kgmeh0x00rm" />
      </main>
      <Footer data-id="element-17" data-mp="3dkl5met7j9lj" />
    </div>;
}